import { SLASH } from "../constants";

/** Current program id from the URL path (first segment), e.g. /con/profile → "con". */
export function getSelectedProgramId(): string {
  return window.location.pathname.split(SLASH).find(Boolean) ?? "";
}

/** @deprecated Prefer {@link getSelectedProgramId} — value captured once at module load. */
export const selectedProgramId = getSelectedProgramId();
